module.exports = __webpack_public_path__ + "static/media/big buddha.2ae4dd29.jpg";